import { useAdmin } from "ui/hooks/useAdmin"
import { useMemo } from "react"
import ImageList from "ui/ImageList"
import WithLightbox from "ui/WithLightbox"

const Slogan = ({context, _path, fieldPath, fieldEntity, ...props}) => {


    const [ref, newPath] = useAdmin(context, _path, fieldPath, fieldEntity, null, "Slogan")
    const val0 = {"en":"ReNiCo: your reliable partner!","it":"ReNiCo: un partner affidabile!","de":"ReNiCo: ein solider und zuverlässiger Partner!"}

    return (
        <div {...props} ref={ref}  elem-slogan="">
            <div>
                <h2>{val0[context.language]??val0.en}</h2>
                <ImageList context={context} _path={newPath} img={[{"name":"cert-dekra.png","url":"/upload/element/exprVal/2026/6/5/cert-dekra.png","mime":"image/png","w":499,"h":695}]}/>
                <WithLightbox lightbox={<ImageList context={context} _path={newPath} img={[{"name":"cert-dekra-en-2025.jpg","url":"/upload/element/exprVal/2025/9/9/cert-dekra-en-2025-1.jpg","mime":"image/jpeg","w":1226,"h":1754}]}/>}>{lightboxProps => (<ImageList context={context} _path={newPath} className="cert-lightbox" img={[{"name":"cert-dekra-en-2025.jpg","url":"/upload/element/exprVal/2025/9/9/cert-dekra-en-2025.jpg","mime":"image/jpeg","w":1226,"h":1754}]} {...lightboxProps}/>)}</WithLightbox>
                <WithLightbox lightbox={<ImageList context={context} _path={newPath} img={[{"name":"cert-tuv-2025-en.jpg","url":"/upload/element/exprVal/2026/6/30/cert-tuv-2025-en-5.jpg","mime":"image/jpeg","w":1226,"h":1754}]}/>}>{lightboxProps => (<ImageList context={context} _path={newPath} className="cert-lightbox" img={[{"name":"cert-tuv-2025-en.jpg","url":"/upload/element/exprVal/2026/6/30/cert-tuv-2025-en-4.jpg","mime":"image/jpeg","w":1226,"h":1754}]} {...lightboxProps}/>)}</WithLightbox>
                <WithLightbox lightbox={<ImageList context={context} _path={newPath} img={[{"name":"cert-tuv-2026-Zert_EN-1090-1_FPC_Renico-en.jpg","url":"/upload/element/exprVal/2026/6/30/cert-tuv-2026-zert_en-1090-1_fpc_renico-en-1.jpg","mime":"image/jpeg","w":1226,"h":1754}]}/>}>{lightboxProps => (<ImageList context={context} _path={newPath} className="cert-lightbox" img={[{"name":"cert-tuv-2026-Zert_EN-1090-1_FPC_Renico-en.jpg","url":"/upload/element/exprVal/2026/6/30/cert-tuv-2026-zert_en-1090-1_fpc_renico-en.jpg","mime":"image/jpeg","w":1226,"h":1754}]} {...lightboxProps}/>)}</WithLightbox>
                <WithLightbox lightbox={<ImageList context={context} _path={newPath} img={[{"name":"cert-tuv-2026-Zert_EN-1090-2_wc_Renico-en.jpg","url":"/upload/element/exprVal/2026/6/30/cert-tuv-2026-zert_en-1090-2_wc_renico-en-1.jpg","mime":"image/jpeg","w":1226,"h":1754}]}/>}>{lightboxProps => (<ImageList context={context} _path={newPath} className="cert-lightbox" img={[{"name":"cert-tuv-2026-Zert_EN-1090-2_wc_Renico-en.jpg","url":"/upload/element/exprVal/2026/6/30/cert-tuv-2026-zert_en-1090-2_wc_renico-en.jpg","mime":"image/jpeg","w":1226,"h":1754}]} {...lightboxProps}/>)}</WithLightbox>
                <ImageList context={context} _path={newPath} img={[{"name":"cert-tuv-sud.png","url":"/upload/element/exprVal/2021/11/22/cert-tuv-sud.png","mime":"image/png","w":203,"h":203}]}/>
            </div>
        </div>
    )
}
export default Slogan
/*
{
  "layout": {
    "data": {
      "name": "div"
    },
    "children": [
      {
        "data": {
          "name": "div"
        },
        "children": [
          {
            "data": {
              "name": "h2",
              "attr": {
                "_i18n": {
                  "it": {
                    "content": "ReNiCo: un partner affidabile!"
                  },
                  "de": {
                    "content": "ReNiCo: ein solider und zuverlässiger Partner!"
                  }
                },
                "content": "ReNiCo: your reliable partner!",
                "_e": {
                  "content": {
                    "is": "exprValExt"
                  }
                }
              }
            }
          },
          {
            "data": {
              "_e": {
                "name": {
                  "_type": "img"
                }
              },
              "name": [
                {
                  "name": "cert-dekra.png",
                  "url": "/upload/element/exprVal/2026/6/5/cert-dekra.png",
                  "mime": "image/png",
                  "w": 499,
                  "h": 695
                }
              ]
            }
          },
          {
            "data": {
              "_e": {
                "name": {
                  "_type": "img"
                }
              },
              "name": [
                {
                  "name": "cert-dekra-en-2025.jpg",
                  "url": "/upload/element/exprVal/2025/9/9/cert-dekra-en-2025.jpg",
                  "mime": "image/jpeg",
                  "w": 1226,
                  "h": 1754
                }
              ],
              "attr": {
                "className": "cert-lightbox"
              }
            },
            "children": [
              {
                "data": {
                  "name": "Lightbox"
                },
                "children": [
                  {
                    "data": {
                      "_e": {
                        "name": {
                          "_type": "img"
                        }
                      },
                      "name": [
                        {
                          "name": "cert-dekra-en-2025.jpg",
                          "url": "/upload/element/exprVal/2025/9/9/cert-dekra-en-2025-1.jpg",
                          "mime": "image/jpeg",
                          "w": 1226,
                          "h": 1754
                        }
                      ]
                    }
                  }
                ]
              }
            ]
          },
          {
            "data": {
              "_e": {
                "name": {
                  "_type": "img"
                }
              },
              "name": [
                {
                  "name": "cert-tuv-2025-en.jpg",
                  "url": "/upload/element/exprVal/2026/6/30/cert-tuv-2025-en-4.jpg",
                  "mime": "image/jpeg",
                  "w": 1226,
                  "h": 1754
                }
              ],
              "attr": {
                "className": "cert-lightbox"
              }
            },
            "children": [
              {
                "data": {
                  "name": "Lightbox"
                },
                "children": [
                  {
                    "data": {
                      "_e": {
                        "name": {
                          "_type": "img"
                        }
                      },
                      "name": [
                        {
                          "name": "cert-tuv-2025-en.jpg",
                          "url": "/upload/element/exprVal/2026/6/30/cert-tuv-2025-en-5.jpg",
                          "mime": "image/jpeg",
                          "w": 1226,
                          "h": 1754
                        }
                      ]
                    }
                  }
                ]
              }
            ]
          },
          {
            "data": {
              "name": [
                {
                  "name": "cert-tuv-2026-Zert_EN-1090-1_FPC_Renico-en.jpg",
                  "url": "/upload/element/exprVal/2026/6/30/cert-tuv-2026-zert_en-1090-1_fpc_renico-en.jpg",
                  "mime": "image/jpeg",
                  "w": 1226,
                  "h": 1754
                }
              ],
              "_e": {
                "name": {
                  "_type": "img"
                }
              },
              "attr": {
                "className": "cert-lightbox",
                "_e": {
                  "className": {
                    "is": "exprValExt"
                  }
                }
              }
            },
            "children": [
              {
                "data": {
                  "name": "Lightbox"
                },
                "children": [
                  {
                    "data": {
                      "name": [
                        {
                          "name": "cert-tuv-2026-Zert_EN-1090-1_FPC_Renico-en.jpg",
                          "url": "/upload/element/exprVal/2026/6/30/cert-tuv-2026-zert_en-1090-1_fpc_renico-en-1.jpg",
                          "mime": "image/jpeg",
                          "w": 1226,
                          "h": 1754
                        }
                      ],
                      "_e": {
                        "name": {
                          "_type": "img"
                        }
                      }
                    }
                  }
                ]
              }
            ]
          },
          {
            "data": {
              "_e": {
                "name": {
                  "_type": "img"
                }
              },
              "name": [
                {
                  "name": "cert-tuv-2026-Zert_EN-1090-2_wc_Renico-en.jpg",
                  "url": "/upload/element/exprVal/2026/6/30/cert-tuv-2026-zert_en-1090-2_wc_renico-en.jpg",
                  "mime": "image/jpeg",
                  "w": 1226,
                  "h": 1754
                }
              ],
              "attr": {
                "className": "cert-lightbox",
                "_e": {
                  "className": {
                    "is": "exprValExt"
                  }
                }
              }
            },
            "children": [
              {
                "data": {
                  "name": "Lightbox"
                },
                "children": [
                  {
                    "data": {
                      "_e": {
                        "name": {
                          "_type": "img"
                        }
                      },
                      "name": [
                        {
                          "name": "cert-tuv-2026-Zert_EN-1090-2_wc_Renico-en.jpg",
                          "url": "/upload/element/exprVal/2026/6/30/cert-tuv-2026-zert_en-1090-2_wc_renico-en-1.jpg",
                          "mime": "image/jpeg",
                          "w": 1226,
                          "h": 1754
                        }
                      ]
                    }
                  }
                ]
              }
            ]
          },
          {
            "data": {
              "_e": {
                "name": {
                  "_type": "img"
                }
              },
              "name": [
                {
                  "name": "cert-tuv-sud.png",
                  "url": "/upload/element/exprVal/2021/11/22/cert-tuv-sud.png",
                  "mime": "image/png",
                  "w": 203,
                  "h": 203
                }
              ]
            },
            "children": []
          }
        ]
      }
    ]
  }
}
*/
